 $('.main-size-upper .wrapper-inner-sizes').click(function() {
   $(this).parent().toggleClass("active");
  });

if ($(window).width() > 767) {
function myFunctionpopup(d) {
    setTimeout(function(){
      console.log('mani');
  $('.main-size-upper .wrapper-inner-sizes').click(function() {
   $(this).parent().toggleClass("active");
  });
    },2000);
}
  $('button#applyFilter').click(function() {
   setTimeout(function(){
location.reload();
   },900);
});
}